import React from 'react';

import {
	parseDateDesktop,
	parseDateDesktopMonth,
	parseEntities,
	today,
	getNextMonday,
	getNextMonth,
} from '../../utils/helpers';
import { CloseIcon, DropdownIcon } from '../../../eagerlyIcons/src/__generated__/icons';


const FilterBarDesktop = ({
  activeFilterDate,
  activeTimestamp,
  activeCinema,
  activeTags,
  availableDates,
  availableDatesMonths,
  availableCinema,
  availableTags,
  currentConfig,
  showFilters,
  handleFilter,
  handleRange,
  dateRange,
  rootElement,
}) => {

  const closeFilterDropdowns = (e) => {
    if (!e.target.classList.contains("custom-select") && e.target.closest(".custom-select") == null) {
      rootElement.removeEventListener("mousedown", closeFilterDropdowns);
      rootElement.querySelectorAll(".js_react_filter .custom-select__trigger").forEach((element) => {
        element.setAttribute("aria-expanded", "false");
      });
    }
  };

  const toggleSelectList = (e) => {
		if (e.target.tagName.toLowerCase() === "li" || e.target.tagName.toLowerCase() === "ul") {
			return;
		}
		rootElement.removeEventListener("mousedown", closeFilterDropdowns);
		rootElement.addEventListener("mousedown", closeFilterDropdowns);
		rootElement.querySelectorAll(".js_react_filter .custom-select__trigger").forEach((element) => {
			if (e.currentTarget.contains(element)) {
			element.setAttribute("aria-expanded", element.getAttribute("aria-expanded") == "true" ? "false" : "true");
			} else {
			element.setAttribute("aria-expanded", "false");
			}
		});
	};

	const buttonLabelCinema = () => {
		if (activeCinema.length === 0) return `${customData.i18n.agenda_filter_choose} ${customData.i18n.agenda_cinema_name}`; //kies bioscoop
		if (activeCinema.length === availableCinema.length) return customData.i18n.agenda_cinema_all; //Alle bioscopen
		return activeCinema.join(", ");
	};

	const buttonLabelTags = () => {
		if (activeTags.length === 0) return `${customData.i18n.agenda_filter_choose} ${customData.i18n.agenda_tag_filter_name}`; //kies filter
		if (activeTags.length === availableTags.length) return customData.i18n.agenda_tag_filter_all; //alle filters
		if (activeTags.length === 1) return parseEntities(activeTags[0]);
		return `${activeTags.length} ${customData.i18n.agenda_tag_filter_selected}`;
	};

	const getPosition = (filterOption) => {
		if (showFilters[0] === filterOption && showFilters[showFilters.length - 1] === filterOption) {
			return "first last";
		} else if (showFilters[0] === filterOption) {
			return "first";
		} else if (showFilters[showFilters.length - 1] === filterOption) {
			return "last";
		}
	};

	const getActiveDateLabels = () => {
		const labels = [];
		if (activeFilterDate) {
			if (currentConfig.theme === 'idea') {
				if (dateRange === 'week') {
					if (today === activeTimestamp) {
						labels.push('Deze week');
					} else if (getNextMonday(today) === activeTimestamp) {
						labels.push('Volgende week');
					}
				} else if (dateRange === 'month') {
					if (today === activeTimestamp) {
						labels.push('Deze maand');
					} else if (getNextMonth(today) === activeTimestamp) {
						labels.push('Volgende maand')
					} else {
						labels.push(parseDateDesktopMonth(activeTimestamp));
					}
				}
			} else {
				labels.push(parseDateDesktopMonth(activeTimestamp));
			}
		}
		return labels;
	}

	const isThisWeek = () => {
		if (activeFilterDate && today === activeTimestamp && dateRange === 'week') return true;
		return false;
	}

	const isNextWeek = () => {
		if (activeFilterDate && getNextMonday(today) === activeTimestamp && dateRange === 'week') return true;
		return false;
	}

	const isThisMonth = () => {
		if (activeFilterDate && today === activeTimestamp && dateRange === 'month') return true;
		return false;
	}

	const isNextMonth = () => {
		if (activeFilterDate && getNextMonth(today) === activeTimestamp && dateRange === 'month') return true;
		return false;
	}

	return (
		<div className="eagerly-agenda__top-nav">
			<div className="agenda-main">
				<h2>Agenda</h2>

				<div className="agenda-filters">

					{showFilters.includes('cinema') && (
					<div className={`custom-select ${getPosition('cinema')}`} onClick={(e) => toggleSelectList(e)}>
						<button
							className={`custom-select__trigger ${activeCinema.length !== 0 ? 'has-selected' : ''}`}
							aria-haspopup="listbox"
							aria-labelledby="bioscoop_label"
							aria-expanded="false"
							id="bioscoop_button"
						>
							<div className="custom-select__label btn" id="bioscoop_label">
								<span className="sr-only">{customData.i18n.agenda_filter_choose}</span>
								Venue filter <DropdownIcon />
							</div>
							{/* {buttonLabelCinema()} */}
						</button>
						<ul className="listbox listbox--multi listbox--multi-cinema" role="listbox" aria-labelledby="bioscoop_label" aria-multiselectable="true" aria-activedescendant="">
							{availableCinema.map((cinemaOption, index) => (
							<li
								onClick={() => handleFilter('filterCinema', cinemaOption)}
								role="option"
								id="date_000"
								aria-selected={activeCinema.includes(cinemaOption) ? 'true' : 'false'}
								data-value={cinemaOption}
								key={index}
								data-cinema_id={cinemaOption}
							>
								{cinemaOption}
							</li>
							))}
						</ul>
					</div>
					)}

					{showFilters.includes('date') && (
						<div className={`custom-select ${getPosition('date')}`} onClick={(e) => toggleSelectList(e)}>
							<button className="custom-select__trigger has-selected js-date-button " aria-haspopup="listbox" aria-labelledby="date_label date_button" aria-expanded="false" id="date_button">
								<div className="custom-select__label btn" id="date_label">
									<span className="sr-only">{customData.i18n.agenda_filter_choose}</span>
									{customData.i18n.agenda_date_name} <DropdownIcon />
								</div>
							</button>
							<ul className="listbox" role="listbox" aria-labelledby="date_label" aria-activedescendant="date_000">

								{currentConfig.date_filter_range && currentConfig.date_presets &&
									<>
										<li
											onClick={() => handleFilter('filterDate', 'all')}
											role="option"
											className={!activeFilterDate ? 'has-focus' : ''}
											id="date_000"
											aria-selected={!activeFilterDate ? 'true' : 'false'}
											data-value={'all'}
										>
											Vanaf vandaag
										</li>
										<li
											onClick={() => handleRange(today, 'week')}
											role="option"
											className={isThisWeek() ? 'has-focus' : ''}
											id="date_000"
											aria-selected={isThisWeek() ? 'true' : 'false'}
											data-value={today}
										>
											Deze week
										</li>
										<li
											onClick={() => handleRange(getNextMonday(today), 'week')}
											role="option"
											className={isNextWeek() ? 'has-focus' : ''}
											id="date_000"
											aria-selected={isNextWeek() ? 'true' : 'false'}
											data-value={getNextMonday(today)}
										>
											Volgende week
										</li>
										<li
											onClick={() => handleRange(today, 'month')}
											role="option"
											className={isThisMonth() ? 'has-focus' : ''}
											id="date_000"
											aria-selected={isThisMonth() ? 'true' : 'false'}
											data-value={today}
										>
											Deze maand
										</li>
										<li
											onClick={() => handleRange(getNextMonth(today), 'month')}
											role="option"
											className={isNextMonth() ? 'has-focus' : ''}
											id="date_000"
											aria-selected={isNextMonth() ? 'true' : 'false'}
											data-value={getNextMonth(today)}
										>
											Volgende maand
										</li>

									</>
								}

								{availableDatesMonths.map((date, index) => (
								<li
									onClick={() => handleRange(date, 'month')}
									role="option"
									className={(activeFilterDate && date === activeTimestamp && dateRange === 'month') ? 'has-focus' : ''}
									id="date_000"
									aria-selected={(activeFilterDate && date === activeTimestamp && dateRange === 'month') ? 'true' : 'false'}
									data-value={date}
									key={index}
								>
									{parseDateDesktopMonth(date)}
								</li>
								))}
							</ul>
						</div>
					)}

					{showFilters.includes('tags') && (
						<div className={`custom-select ${getPosition('tags')}`} onClick={(e) => toggleSelectList(e)}>
							<button
								className={`custom-select__trigger ${activeTags.length !== 0 ? 'has-selected' : ''}`}
								aria-haspopup="listbox"
								aria-labelledby="bioscoop_label"
								aria-expanded="false"
								id="bioscoop_button"
							>
								<div className="custom-select__label btn" id="bioscoop_label">
									<span className="sr-only">{customData.i18n.agenda_filter_choose}</span>
									{customData.i18n.agenda_tag_filter_name} <DropdownIcon />
								</div>
								{/* {buttonLabelTags()} */}
							</button>
							<ul className="listbox  listbox--multi  listbox--multi" role="listbox" aria-labelledby="tags_label" aria-multiselectable="true" aria-activedescendant="">
								{availableTags.map((tag, index) =>
								currentConfig.tags_hide_from_dropdown.includes(tag) ? (
									''
								) : (
									<li onClick={() => handleFilter('filterTags', tag, false)} role="option" id="date_000" aria-selected={activeTags.includes(tag) ? 'true' : 'false'} data-value={tag} key={index}>
										{parseEntities(tag)}
									</li>
								)
								)}
							</ul>
						</div>
					)}
				</div>
			</div>

			<div className="agenda-filter-sub">
				<div className="agenda-active-filters">
					{/* display of active filter options, only for vorstin/idea */}
					{ currentConfig.date_filter_range &&
						getActiveDateLabels().map((val, index) =>
							<button onClick={() => handleFilter('filterDate', 'all')} key={index} className="btn btn--reset-date">
								<span>{val}</span>
								<CloseIcon />
							</button>
						)
					}

					{/* idea */}
					{ currentConfig.shows_tags_as_labels &&
						activeTags.map((tag, index) =>
							<button onClick={() => handleFilter('filterTags', tag, false)} key={index} className="btn btn--reset-tag">
								<span>{parseEntities(tag)}</span>
								<CloseIcon />
							</button>
						)
					}
				</div>

				{ currentConfig.show_filter_reset &&
					<button onClick={() => handleFilter("resetFilters", null)} className="filter-bar__reset-all">
						<span>{customData.i18n.agenda_delete_filters}</span> <CloseIcon />
					</button>
				}
			</div>
		</div>
	);
};

export default FilterBarDesktop;
